import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

interface LoadingDotsProps {
  count?: number;
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "secondary" | "muted";
  speed?: number;
  className?: string;
}

export function LoadingDots({
  count = 3,
  size = "md",
  variant = "primary",
  speed = 300,
  className = "",
}: LoadingDotsProps) {
  const [dots, setDots] = useState<number[]>([]);
  const [activeDot, setActiveDot] = useState(0);

  useEffect(() => {
    setDots(Array.from({ length: count }, (_, i) => i));
  }, [count]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDot((prev) => (prev + 1) % count);
    }, speed);

    return () => clearInterval(interval);
  }, [count, speed]);

  const sizeClasses = {
    sm: "aero:h-1.5 aero:w-1.5",
    md: "aero:h-2.5 aero:w-2.5",
    lg: "aero:h-3.5 aero:w-3.5",
  };

  const variantClasses = {
    primary: "aero:bg-brand-primary",
    secondary: "aero:bg-secondary",
    muted: "aero:bg-muted-foreground",
  };

  return (
    <div
      className={cn(
        "aero:flex aero:items-center aero:justify-center aero:space-x-2",
        className
      )}
    >
      {dots.map((dot) => (
        <span
          key={dot}
          className={cn(
            "aero:!rounded-full aero:transition-all aero:duration-200",
            sizeClasses[size],
            variantClasses[variant],
            activeDot === dot
              ? "aero:opcaity-100 aero:scale-100"
              : "aero:opcaity-40 aero:scale-75"
          )}
        />
      ))}
    </div>
  );
}
